var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDisabledFailureCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34433",
    "data-name": "Group 34433",
    transform: "translate(-1651 -333)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1131",
    "data-name": "Ellipse 1131",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(1651 333)",
    fill: "#b8bbbf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_34435",
    "data-name": "Group 34435",
    transform: "translate(-0.091 -0.108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73117",
    "data-name": "Path 73117",
    d: "M4290.589-6634.061l9.182-9.217",
    transform: "translate(-2632.09 6983.777)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73118",
    "data-name": "Path 73118",
    d: "M4299.771-6634.061l-9.182-9.217",
    transform: "translate(-2632.09 6983.777)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledFailureCheck);
export default __webpack_public_path__ + "static/media/disabled-failure-check.7272cb9888b72f5d641d18d1942ed393.svg";
export { ForwardRef as ReactComponent };